import { Box, Text } from '@rbilabs/universal-components';

export const Card = Box.withConfig({
  background: Styles.color.cardBackground,
  minHeight: '$6',
  justifyContent: 'center',
  alignItems: 'center',
  shadow: {
    base: 'none',
    md: '1',
  },
  borderRadius: Styles.borderRadius,
  marginTop: '$4',
  flexDirection: {
    base: 'column',
    md: 'row',
  },
  focusable: true,
  width: '140px',
  overflow: 'hidden',
  padding: '$4',
});

export const ModalContainer = Box.withConfig({
  alignItems: 'center',
  position: 'relative',
  zIndex: 0,
});

export const BottomLayer = Box.withConfig({
  zIndex: 1,
  top: 0,
  bottom: 0,
  justifyContent: 'center',
});

export const TopLayer = Box.withConfig({
  zIndex: 2,
  position: 'absolute',
});

export const Message = Text.withConfig({
  variant: 'headerTwo',
  textAlign: 'center',
  lineHeight: 'lg',
  marginBottom: '$0',
});
